module.exports = __webpack_public_path__ + "0d716baeb3599cb26d1ae2e2cf0ccd14.pdf";